import { Schema } from "effect";
import { HttpApiEndpoint, HttpApiGroup, HttpApiMiddleware, HttpApiSchema } from "effect/unstable/httpapi";

export const INTERNAL_BUNDLE_PATH = "/api/internal/bundle";
export const INTERNAL_BUNDLE_HEADER = "x-workerstation-internal-bundle";
export const INLINE_BUNDLE_CHARACTERS = 4 * 1024 * 1024;

const OptionalText = /* @__PURE__ */ (() => Schema.optionalKey(Schema.String))();
const OptionalBoolean = /* @__PURE__ */ (() => Schema.optionalKey(Schema.Boolean))();
const OptionalStrings = /* @__PURE__ */ (() => Schema.optionalKey(Schema.Array(Schema.String).pipe(Schema.mutable)))();
const TextFiles = /* @__PURE__ */ (() => Schema.Record(Schema.String, Schema.String))();

/** The HTTP transport carries text files; native FileSystem/setup functions cannot cross JSON. */
export const InternalBundleOptions = /* @__PURE__ */ (() => Schema.Struct({
  files: TextFiles,
  entryPoint: OptionalText, bundle: OptionalBoolean,
  externals: OptionalStrings, target: OptionalText,
  minify: OptionalBoolean, sourcemap: OptionalBoolean,
  registry: OptionalText, jsx: Schema.optionalKey(Schema.Literals(["transform", "preserve", "automatic"])),
  jsxImportSource: OptionalText, define: Schema.optionalKey(TextFiles),
  loader: Schema.optionalKey(Schema.Record(Schema.String, Schema.Literals(["js", "jsx", "ts", "tsx", "json", "css", "text", "binary", "base64", "dataurl"]))),
  conditions: OptionalStrings, virtualModules: Schema.optionalKey(TextFiles),
  __dangerouslyUseEsBuildPluginsDoNotUseOrYouWillBeFired: Schema.optionalKey(Schema.Array(Schema.Json).pipe(Schema.mutable))
}))();
export type InternalBundleOptions = typeof InternalBundleOptions.Type;

/** JSON's existing ArrayBuffer representation is retained by this wire schema. */
const bundleResult = <Data extends Schema.Constraint>(data: Data) => Schema.Struct({
  mainModule: Schema.String,
  modules: Schema.Record(Schema.String, Schema.Union([Schema.String, Schema.Struct({
    js: OptionalText, cjs: OptionalText, text: OptionalText,
    data: Schema.optionalKey(data), json: Schema.optionalKey(Schema.Union([Schema.Record(Schema.String, Schema.Json), Schema.Array(Schema.Json)]))
  })])),
  wranglerConfig: Schema.optionalKey(Schema.Struct({ main: OptionalText, compatibilityDate: OptionalText, compatibilityFlags: OptionalStrings })),
  warnings: OptionalStrings
});
export const InternalBundleResult = /* @__PURE__ */ (() => bundleResult(Schema.Struct({})))();
export const InternalBundleNativeResult = /* @__PURE__ */ (() => bundleResult(Schema.instanceOf(ArrayBuffer)))();
export type InternalBundleResult = typeof InternalBundleResult.Type;
export const InternalBundleKey = /* @__PURE__ */ (() => Schema.String.check(Schema.isPattern(/^build-bundle\/v1\/[a-f0-9]{24}$/)).pipe(Schema.brand("InternalBundleKey")))();
export type InternalBundleKey = typeof InternalBundleKey.Type;
export const InternalBundleResponse = /* @__PURE__ */ (() => Schema.Union([
  Schema.Struct({ kind: Schema.Literal("inline"), result: InternalBundleResult }),
  Schema.Struct({ kind: Schema.Literal("r2"), key: InternalBundleKey, resultDigest: Schema.String.check(Schema.isPattern(/^sha256:[a-f0-9]{64}$/)) })
]))();
export type InternalBundleResponse = typeof InternalBundleResponse.Type;
/** Answers a request without the credential header with the hidden 404. */
export class InternalBundleCredential extends HttpApiMiddleware.Service<InternalBundleCredential>()("workerstation/runtime/InternalBundleCredential") {}
export const InternalBundleApi = HttpApiGroup.make("internalBundle").add(HttpApiEndpoint.post("compile", INTERNAL_BUNDLE_PATH, {
  headers: Schema.Struct({ [INTERNAL_BUNDLE_HEADER]: Schema.String }), payload: InternalBundleOptions, success: InternalBundleResponse,
  error: [Schema.Literal("Invalid bundle options.").pipe(HttpApiSchema.asText()).annotate({ httpApiStatus: 400 }),
    Schema.Literal("Forbidden").pipe(HttpApiSchema.asText()).annotate({ httpApiStatus: 403 }),
    Schema.Struct({ error: Schema.String }).annotate({ httpApiStatus: 500 })]
})).middleware(InternalBundleCredential);
